export const ReferenceDropdown = [
    {
      label: "Device",
      value: "Device",
    },
    {
      label: "Site",
      value: "Site",
    },
    {
      label: "User",
      value: "User",
    },
    {
        label: "Rates",
        value: "Rates",
      },
      {
        label: "Data",
        value: "Data",
      },
      {
        label: "Job",
        value: "Job",
      },
      {
        label: "Install",
        value: "Install",
      },
  ];
  